<template>
  <div id="home">
    <HomeBanner />
    <WhyChooseUs />
    <HeaderBar />

    <USSDPayment id="ussd_payment" />
    <BankTransfer id="bank_transfer" />
    <CashOut id="ussd_cashout"/>
    <Corporate id="corporate_payment" />
    <Adept id="adept"/>

    <PaymentLink />

    <Features id="features" />

    <AccessChannels id="channels" />

    <AboutSection id="aboutUs" />
    <!-- <Team /> -->

    <GridPost id="blog" />

    <ContactArea id="contact" />
    <ContactUs />

    <Partners id="partners"/>
    <DownloadApp />

    <AccountCreate />
    <Footer />
  </div>
</template>

<script>
import AboutSection from "../components/aboutusComponents/AboutSection";

import HomeBanner from "../components/homeComponents/HomeBanner";
import WhyChooseUs from "../components/homeComponents/WhyChooseUs";

import USSDPayment from "../components/homeComponents/USSDPayment";
import CashOut from "../components/homeComponents/CashOut";

import Features from "../components/homeComponents/Features";

import ContactUs from "../components/homeComponents/ContactUs";
import Partners from "../components/homeComponents/Partners";
import DownloadApp from "../components/homeComponents/DownloadApp";
import AccountCreate from "../components/AccountCreate";
import Footer from "../components/Footer";
import BankTransfer from "../components/homeComponents/BankTransfer";
import Corporate from "../components/homeComponents/Corporate";
import PaymentLink from "../components/homeComponents/PaymentLink";
import HeaderBar from "../components/homeComponents/HeaderBar";
import ContactArea from "../components/contactComponents/ContactArea";
import AccessChannels from "../components/homeComponents/AccessChannels";
import GridPost from "../components/blogComponents/GridPost";

import Adept from "../components/homeComponents/Adept";

export default {
  name: "home",
  components: {
    HeaderBar,
    HomeBanner,
    WhyChooseUs,
    USSDPayment,
    CashOut,
    Features,
    ContactUs,
    Partners,
    DownloadApp,
    AccountCreate,
    Footer,
    BankTransfer,
    Corporate,
    PaymentLink,
    AboutSection,
    ContactArea,
    AccessChannels,
    GridPost,
    Adept
  }
};
</script>
